import React from 'react'
import ROCKET_IMG from 'images/blast-off-rocket.svg'

import SuccessLander from 'components/SuccessLander'

const HEADER_TEXT = 'Woohoo!'
const BUTTON_TEXT = 'Go to my dashboard'
const SUBHEADER_TEXT = 'It’s time to unwrap your brand new Drift account'

const OnboardingSuccessStep = ({ onContinue }) => (
  <SuccessLander className="onboarding-success-lander"
    image={ROCKET_IMG}
    headerText={HEADER_TEXT}
    buttonText={BUTTON_TEXT}
    onButtonClick={onContinue}
    subheaderText={SUBHEADER_TEXT}/>
)

export default OnboardingSuccessStep


// WEBPACK FOOTER //
// ./src/layouts/OnboardingSuccessStep/index.js